import { render, staticRenderFns } from "./YourBike.vue?vue&type=template&id=52d61471&scoped=true"
import script from "./YourBike.vue?vue&type=script&lang=js"
export * from "./YourBike.vue?vue&type=script&lang=js"
import style0 from "./YourBike.vue?vue&type=style&index=0&id=52d61471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d61471",
  null
  
)

export default component.exports